// @flow
/** @jsx h */
import { h } from 'preact';
import { route } from 'preact-router';
import TilesContainer from '../tilesContainer';
import { tracker, UserActionType } from '../../../tracking';
import CustomSlider from '../../common/customSlider';
import { connect } from 'react-redux';
import howToBuyProductAction from '../../../actions/howToBuyProductActions';
import { useRef } from 'preact/hooks';
import { generateUrlWithParams } from '../../../utils/routeHandler';
import { styled } from 'goober';
import actionType from '../../../actions/howToBuyProductActions/actionType';
import ProductCard from '../../productCard';
import { howToBuyProductRoute } from '../../../alias/homeRoutes';

const ProductsCardContainer = styled('div')`
  margin-right: 12px;
`;

const Products = (props) => {
  const { products, pageKey } = props;
  const customSliderRef = useRef(null);

  return (
    <TilesContainer
      title='Top Products'
      subTitle='Shop smart with Cardless EMI'
      additionalButton={false}
      nextSlide={() => {
        customSliderRef.current.nextSlide();
      }}
      prevSlide={() => {
        customSliderRef.current.prevSlide();
      }}>
      <CustomSlider
        childWidth={380}
        outerContainerClass={{ width: '100%' }}
        ref={customSliderRef}
        noOfSlides={products.length}
        customSettings={{
          arrows: true,
          responsive: [
            {
              breakpoint: 768,
              settings: {
                arrows: false,
              },
            },
          ],
        }}>
        {products.map((item, i) => {
          return (
            <ProductsCardContainer>
              <ProductCard
                productCardClick={() => {
                  tracker.trackUserInteraction(
                    UserActionType.CLICK,
                    `bic_product_tile_rank_${i + 1}`,
                    pageKey,
                    {
                      productName: item.name,
                      type: item.type,
                      productId: item.id,
                      merchantName: item.handle,
                    },
                  );
                  props.howToBuyProductAction(actionType.redirectToHTBProduct, {
                    referralUrl:
                      window.location.pathname + window.location.search,
                  });
                  return route(
                    generateUrlWithParams(
                      `${howToBuyProductRoute.internalRoute}${item.handle}/${
                        item.id
                      }`,
                    ),
                  );
                }}
                productBackgroundImg={item.tileImgUrl}
                index={i}
              />
            </ProductsCardContainer>
          );
        })}
      </CustomSlider>
    </TilesContainer>
  );
};
const mapStateToProps = ({ buyWithInstacred }) => {
  const { home } = buyWithInstacred || {};
  const { products } = home;
  return {
    products,
  };
};
export default connect(
  mapStateToProps,
  { howToBuyProductAction },
)(Products);



// WEBPACK FOOTER //
// ./componentsBICRevamp/buyWithInstacredLanding/Products/index.js